import ReplacementProductLinkComponent, {
    ReplacementProductLinkStyles,
} from "@gemeco/CustomComponents/ReplacementProductLink";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

export interface ReplacementProductNumberStyles {
    replacementProductLinkStyles: ReplacementProductLinkStyles;
}

export const replacementPartNumberStyles: ReplacementProductNumberStyles = {
    replacementProductLinkStyles: {
        labelText: {
            size: 16,
            weight: "bold",
            css: css`
                margin-right: 15px;
            `,
        },
        valueText: {
            size: 16,
            css: css`
                margin-bottom: 5px;
            `,
        },
    },
};

const styles = replacementPartNumberStyles;

type Props = HasProduct & WidgetProps;

const ReplacementProductLink: React.FC<Props> = ({ product }) => {
    if (!product || !product.replacementProductUrl) {
        return null;
    }
    return <ReplacementProductLinkComponent extendedStyles={styles.replacementProductLinkStyles} />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ReplacementProductLink),
    definition: {
        displayName: "Replacement Product",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
